import { Navigate, Outlet } from 'react-router';

import { useAuth } from 'components/providers/AuthProvider';

export const HomeLayout = () => {
  const { session } = useAuth();

  if (session) {
    return <Navigate to="/campaigns" replace />;
  }

  return <Outlet context={{ session }} />;
};
